<template>
  <v-container>
      <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" color="#FEBD08" right :timeout="timeout">
      <v-layout wrap>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="snackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap py-3 py-lg-16>
      <v-flex xs12 class="head">Contact Us </v-flex>
      <v-flex sm6 md6 pt-3 pt-md-5>
        <v-layout wrap>
          <v-flex xs8 pb-md-12 pb-5 style="font: 16px robotoregular" class="clr"
            >Feel free to contact us any time and We will get back to you as
            soon as we can
          </v-flex>
          <v-flex xs12>
            <v-layout wrap class="clr">
              <v-flex align-self-center xs2 md1  pb-2 
                ><v-icon color="#B2B2B2">mdi-email</v-icon>
              </v-flex>
              <v-flex pb-2  align-self-center xs10 md11 style="font: 16px robotoregular;"
                >hivekeep@gmail.com
              </v-flex>
              <v-flex xs2 md1
                ><v-icon color="#B2B2B2">mdi-phone</v-icon>
              </v-flex>
              <v-flex xs10 md11>
                <span style="font-size: 15px">+91 9484 000 000</span>
                <br /><span style="font-size: 15px">+91 9484 000 000</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex pt-md-12 pt-5 xs2 md1 class="clr"
            ><v-icon size="29px" color="#B2B2B2">mdi-twitter</v-icon>
          </v-flex>
          <v-flex pt-md-12 pt-5 xs2 md1 class="clr"
            ><v-img
              width="25px"
              contain
              height="25px"
              src="../../assets/images/facebook.svg"
            ></v-img>
          </v-flex>
          <v-flex pt-md-12 pt-5 xs2 md1 class="clr">
            <v-img width="25px" src="../../assets/images/linkedin.svg"></v-img>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm6 md6>
        <v-form ref="form">
        <v-layout wrap>
          <v-flex xs12 class="subhead" style="color: black" pt-4 pb-5
            >Leave us a Message
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outlined
              v-model="contact.name"
              :rules="[rules.required]"
              label="Name"
              dense
              class="textfd"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              outlined
              label="Email"
              dense
              v-model="contact.email"
                :rules="[rules.email]"
              class="textfd"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              outlined
              label="Leave your message here."
              class="textfd"
              :rules="[rules.required]"
              v-model="contact.message"
            >
            </v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn tile width="100%" @click="add()" dark color="#FEBD08">SEND </v-btn>
          </v-flex>
           
        </v-layout>
        </v-form>
      </v-flex>
      <v-flex
        xs12
        class="hidden-sm-and-down hidden-lg-and-up"
        style="height: 330px"
      >
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      msg: "",
      timeout: 5000,
      snackbar: false,
      appLoading: false,
      contact: { name: null, email: null, message: null },
       rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      
    };
  },
  methods: {
    add() {
      if(this.$refs.form.validate())
      {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/contact/us",
        data: this.contact,
        // headers: {
        //   "x-auth-token": localStorage.getItem("token"),
        // },
      })
        .then((response) => {
          if (response.data.status) {
            this.msg = "Successfully added message";
            this.snackbar = true;
             Object.keys(this.contact).forEach((key) => (this.contact[key] = null));
            this.appLoading = false;
              this.$refs.form.resetValidation();
          } else {
            this.msg = response.data.msg;
            this.snackbar = true;
          
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
      }
    },
  },
};
</script>